import { computed, ref } from 'vue'
import { useBooksySegment, isBooksyCom } from '@booksy-com/vue-tools'
import { useAnalyticsCommonParams } from './common-params'

import { SEGMENT_KEYS } from './consts'

type BooksySegmentInstance = ReturnType<typeof useBooksySegment>

let INSTANCE: BooksySegmentInstance | null = null

const SEGMENT_KEY = isBooksyCom()
  ? SEGMENT_KEYS.PRODUCTION
  : SEGMENT_KEYS.TEST

export function createSegment (): BooksySegmentInstance {
  if (!INSTANCE) {
    const {
      country,
      businessId,
      userId,
    } = useAnalyticsCommonParams()

    const userTraits = computed(() => ({
      userId: userId.value ?? '',
      ...(businessId.value && { business_id: businessId.value }),
      ...(country.value && { country: country.value }),
    }))

    INSTANCE = useBooksySegment({
      writeKey: SEGMENT_KEY,
      userTraits,
      ...(isBooksyCom()
        ? {}
        : {
          consents: ref({
            marketing: true,
          }),
        }),
    // @booksy-com/vue-tools SegmentConfig.Consents is stricter than the legacy marketing-only ref we pass in non-production.
    } as unknown as Parameters<typeof useBooksySegment>[0])
  }

  return INSTANCE
}
